import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, ISupplier, ISupplierAccountsQueryParams } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<ISupplier>, ISupplierAccountsQueryParams>>(undefined as any);
